import logar from "./logar";
import postInstituicao from "./postInstituicao";
import postLogin from "./postLogin";
import postMembro from "./postMembro";
import unRegister from "./unRegister";

type Login = {
  nome: string;
  cpf: string;
  email: string;
  senha: string;
};
type Instituicao = {
  nome: string;
  cnpj: string;
  email: string;
  telefone: string;
  endereco: {
    cep: string;
    cidade: string;
    estado: string;
    bairro: string;
    rua: string;
    numero: string;
    complemento?: string;
  };
};
type Membro = {
  rg: string;
  orgao: string;
  cargo: string;
  endereco: {
    cep: string;
    cidade: string;
    estado: string;
    bairro: string;
    rua: string;
    numero: string;
    complemento?: string;
  };
  data_inicio_mandato: string;
  data_fim_mandato: string;
};

const registroInicialCompleto = async (
  dadosLogin: Login,
  dadosInstituicao: Instituicao,
  dadosMembro: Membro
) => {
  const { memberCredential, instCredential, token, userCredential } =
    await postLogin(
      dadosLogin.nome,
      dadosLogin.cpf.replace(/\D/g, ""),
      dadosLogin.email,
      dadosLogin.senha
    ).then(async (userCredential) => {
      const { memberCredential, instCredential, token } = await logar(
        dadosLogin.cpf.replace(/\D/g, ""),
        dadosLogin.senha
      ).then(async (loginResponse) => {
        const token = loginResponse.token.plainTextToken;
        console.log(token);

        const { memberCredential, instCredential } = await postInstituicao(
          token,
          dadosInstituicao.nome,
          dadosInstituicao.cnpj.replace(/\D/g, ""),
          dadosInstituicao.email,
          dadosInstituicao.telefone.replace(/\D/g, ""),
          dadosInstituicao.endereco.cep,
          dadosInstituicao.endereco.cidade,
          dadosInstituicao.endereco.estado,
          dadosInstituicao.endereco.bairro,
          dadosInstituicao.endereco.rua,
          dadosInstituicao.endereco.numero,
          dadosInstituicao.endereco.complemento
        ).then(async (instCredential) => {
          const memberCredential = await postMembro(
            token,
            dadosMembro.rg,
            dadosMembro.orgao,
            dadosMembro.cargo,
            dadosMembro.endereco.cep,
            dadosMembro.endereco.cidade,
            dadosMembro.endereco.estado,
            dadosMembro.endereco.rua,
            dadosMembro.endereco.bairro,
            dadosMembro.endereco.numero,
            dadosMembro.data_inicio_mandato,
            dadosMembro.data_fim_mandato,
            true,
            userCredential.id,
            instCredential.id,
            dadosMembro.endereco.complemento
          ).then(async (memberCredential) => {
            return memberCredential;
          });
          return {
            memberCredential,
            instCredential,
          };
        });
        return {
          memberCredential,
          instCredential,
          token,
        };
      });
      return {
        memberCredential,
        instCredential,
        token,
        userCredential,
      };
    });
  return {
    userCredential,
    instCredential,
    memberCredential,
    token,
  };
};
export default registroInicialCompleto;
